var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEmptyReleaseNotes = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 143,
  height: 143,
  viewBox: "0 0 143 143",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h143v143H0z"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "#00B177",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  d: "M104.333 56.049v52.03c0 6.605-5.33 11.96-11.904 11.96H26.952c-3.287 0-5.952-2.677-5.952-5.98V30.333c0-3.303 2.665-5.98 5.952-5.98h46.429m-35.714 0V132M104.333 10v31.098M87.667 24.353H121M56.714 50.069h23.81M56.714 73.99h23.81"
})))));
export default SvgEmptyReleaseNotes;